import { useEffect, useRef } from "react";
import { FormSelect } from "react-bootstrap";

// Need to refactor to pass through other attributes
export function ObjectSelector(props) {
	let {
		// General Setup
		options,         // Array of objects
		valueAttribute,  // Field used for the drop-down value (should be unique)
		labelAttribute,  // Field used for the drop-down label
		chooseText,      // Text to use for "no object"
		groupedOptions,  // Options that are grouped instead of regular
		
		// Defaults
		defaultObject,   // Default object used to pick default option
		defaultValue,    // Alternate - default value used to pick default option

		// Actions
		onValueChange,   // On a change, send the new value
		onObjectChange,  // On a change, send the new object
		onChange,        // The "real" HTML selector onChange event (runs last)
		...passableProps
	} = props;

	// Refs
	let selectRef = useRef();

	if(defaultObject != null) {
		defaultValue = defaultObject[valueAttribute];
	}

	let onSelectionChanged = (evt) => {
		// Find selected object
		let idx = evt.target.selectedIndex;
		let newObj = null;
		let newVal = null;
		if(idx > 0) {
			newObj = options[idx - 1];
			newVal = newObj[valueAttribute];
		}

		// Propagate changes
		onValueChange?.(newVal);
		onObjectChange?.(newObj);

		onChange?.(evt);
	};

	// Auto-select option at startup if a default is set
	useEffect(() => {
		let newIdx = 0;
		let tmpIdx = 1; // Skip "choose" element
		(options||[]).forEach((obj, idx) => {
			if(obj[valueAttribute] == defaultValue) {
				newIdx = tmpIdx;
			}
			tmpIdx += 1;
		});

		(groupedOptions || []).forEach((gobj, idx) => {
			gobj.options.forEach((obj, idx) => {
				if(obj[valueAttribute] == defaultValue) {
					newIdx = tmpIdx;
				}
				tmpIdx += 1;
			});
		});
		selectRef.current.selectedIndex = newIdx;
	});

	// If I only have grouped options, if the first group has a blank name, then
	// they get treated as ungrouped.
	if(options == null && groupedOptions != null) {
		if(groupedOptions.length > 0) {
			if(groupedOptions[0].name == "") {
				options = groupedOptions[0].options;
				groupedOptions = groupedOptions.slice(1);
			}
		}
	}

	return (
		<FormSelect ref={selectRef} onChange={onSelectionChanged} {...passableProps}>
			<option value="">{chooseText || "* Choose *"}</option>
			{options != null && options.map(obj => <option key={obj[valueAttribute]} value={obj[valueAttribute]}>{obj[labelAttribute]}</option>)}
			{groupedOptions != null && groupedOptions.map(gobj => <optgroup label={gobj.name} key={gobj.name}>
				{gobj.options.map(obj => <option key={obj[valueAttribute]} value={obj[valueAttribute]}>{obj[labelAttribute]}</option>)}
				</optgroup>)}
		</FormSelect>
	);
}